import { matchRoutes } from 'react-router-config';
import { Request } from 'express';

import routes from '@rover/react-app/src/routes';

const getMatchedRoute = (path: string) => {
  const matchingRoutes = matchRoutes(routes, path);

  let baseRoute;
  let pageRoute;
  if (matchingRoutes && matchingRoutes.length >= 2) {
    [baseRoute, pageRoute] = matchingRoutes;
  }

  return { baseRoute, pageRoute };
};

export const getPageRouteComponentName = (req: Request): string => {
  const { pageRoute } = getMatchedRoute(req.path);
  return pageRoute?.route?.componentName || 'unknown_componentname';
};

export const getPageRoutePageCategory = (req: Request): string => {
  const { pageRoute } = getMatchedRoute(req.path);
  return pageRoute?.route?.pageCategory || 'unknown_pagecategory';
};

export const getPageRouteConcept = (req: Request): string => {
  const { pageRoute } = getMatchedRoute(req.path);
  return pageRoute?.route?.concept[1] || 'unknown_concept';
};

export default getMatchedRoute;
